module.exports = __webpack_public_path__ + "media/application/images/ui/logo-peoples-choice-bc83b76ed3699ee4a040295542db889a.png";